import SectionTitle from "@/components/SectionTitle";
import Button from "@/components/Button";

export default function About() {
  return (
    <section className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="About"
          title="A developer who loves craft"
          subtitle="Focused on delightful interactions, accessibility, and performance to bring ideas to life."
          center
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="relative">
            <div className="absolute -left-6 -top-6 h-24 w-24 rounded-full bg-neon-mint/20 blur-2xl" />
            <div className="absolute -right-6 -bottom-6 h-20 w-20 rounded-full bg-neon-pink/20 blur-2xl" />
            <img
              
              alt="Profile"
              className="relative z-10 aspect-square w-full max-w-xs rounded-2xl object-cover border border-white/10 shadow-glow"
              loading="lazy"
            />
          </div>

          <div className="space-y-5">
            <p className="text-gray-700 dark:text-gray-300">
              I’m a 18-year-old programmer passionate about IoT and Robotics—constantly exploring innovative ways to merge technology with everyday life.
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              I hide clever secrets and interactive surprises in my work; a treasure hunt for those with a keen eye.
            </p>

            <ul className="mt-4 flex flex-wrap gap-3 text-sm">
              <li className="rounded-full border border-white/10 bg-white/5 px-3 py-1">🎨 Creative</li>
              <li className="rounded-full border border-white/10 bg-white/5 px-3 py-1">🧠 Curious</li>
              <li className="rounded-full border border-white/10 bg-white/5 px-3 py-1">☕ Caffeinated</li>
            </ul>

            <div className="pt-2 flex items-center gap-3">
              <Button as="a" href="#projects" variant="solid" onClick={(e) => e.preventDefault()}>
                View projects
              </Button>
              <Button as="a" href="#contact" variant="outline" onClick={(e) => e.preventDefault()}>
                Contact
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
